import { useEffect } from "react";
import { getOrCreateSessionId } from "../services/sessionId";
import { recordVisit } from "../services/statsApi";

const LAST_VISIT_KEY = "1755-session:lastVisit";

export default function useVisitPing() {
  useEffect(() => {
    if (typeof localStorage === "undefined") return;
    const today = new Date().toISOString().slice(0, 10);
    const lastVisit = localStorage.getItem(LAST_VISIT_KEY);
    if (lastVisit === today) return;

    const sessionId = getOrCreateSessionId();
    if (!sessionId) return;
    const lang = (navigator.language || "fr").toLowerCase().slice(0, 2);

    recordVisit(sessionId, lang)
      .then(() => localStorage.setItem(LAST_VISIT_KEY, today))
      .catch(() => {
        // best-effort
      });
  }, []);
}
